import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Programassociales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Bienestar de las Personas Cuidadoras de <br /> Personas con Discapacidad</h3>
          <hr className='hr-gob' />
        </div>
      </div>
   
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Bajo el compromiso de buscar el bienestar del pueblo e instrumentar apoyos diversos para las y los cuidadores de personas con discapacidad permanente del Estado de Hidalgo, el Programa “Bienestar de Personas Cuidadoras de Personas con Discapacidad”, de reciente creación y sin precedentes; busca contribuir con un apoyo económico bimestral de $2,2000 pesos a personas cuidadoras de personas con discapacidad que habiten en cualquiera de los 84 municipios del Estado de Hidalgo. Siendo el primero en el país que prioriza condiciones típicamente rezagadas como la discapacidad múltiple (dos o más de las siguientes: auditiva, intelectual, psicosocial, física neuromotora, visual), física con movilidad reducida, intelectual profunda y psicosocial profunda, que enfrentan mayores obstáculos e incomprensión social.
                </p>
                <p>
                También representa una medida de justicia social que contribuye al desarrollo económico al facilitar la participación de los cuidadores en la vida económica del  Estado de Hidalgo, al aliviar la carga financiera y el acceso a servicios, necesidades fundamentales y recursos, que de otra manera no podrían solventar, por la situación de vulnerabilidad y desventaja para acceder a un empleo.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir al bienestar de personas cuidadoras mayores de edad de personas con discapacidad permanente.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Este programa se dirige a familiares, tutores o personas de apoyo que sean mayores de edad, que se dediquen de tiempo completo al cuidado de personas con discapacidad permanente, que no perciban remuneración, y que la persona a la que cuida se encuentre en los supuestos de discapacidad siguientes:
                </p><p>
                <ul>
                  <li>
                  Múltiple (dos o más de las siguientes: auditiva, intelectual, psicosocial, física-neuromotora y visual).
                  </li>
                  <li>
                  Física con movilidad reducida (que no pueda realizar actividades de la vida diaria).
                  </li>
                  <li>
                  Intelectual profunda, y
                  </li>
                  <li>
                  Psicosocial Profunda
                  </li>
                </ul>
                
                Que se consideren con gravedad severa, conforme al catálogo interno de la Secretaría de Bienestar e Inclusión Social (SEBISO), que habite en los 84 municipios del estado, dando prioridad  las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de atención prioritaria indígena del estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El programa tiene cobertura en todo el territorio del Estado Libre y Soberano de Hidalgo
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Desarrollo Social y Humano</b></li>
                <li><b>Dirección General para la Inclusión de Personas con Discapacidad</b></li>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                L. D. Ricardo Gómez Moreno: Secretario de la SEBISO
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 717 8000 Ext. 8563 y 7718121176
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_de_Personas_Cuidadoras_de_Personas_con_Discapacidad_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                </ul>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatorias</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_CUIDADORES_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Marzo 2026</a>
                </li>
                </ul>
                
              </div>
            </div>
            
          </div>
        </div>
     
      </div>    
    </div>
  );
};

export default Programassociales;